import { render, staticRenderFns } from "./StateroomDetail.vue?vue&type=template&id=4af823ea&scoped=true"
import script from "./StateroomDetail.vue?vue&type=script&lang=js"
export * from "./StateroomDetail.vue?vue&type=script&lang=js"
import style0 from "./StateroomDetail.vue?vue&type=style&index=0&id=4af823ea&prod&lang=less&scoped=true"
import style1 from "./StateroomDetail.vue?vue&type=style&index=1&id=4af823ea&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af823ea",
  null
  
)

export default component.exports